/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {SurveyFormInputDate} from "../SurveyFormInputDate";
import {SurveyFormInputBoolean} from "../SurveyFormInputBoolean";
import {SurveyFormComposedInput} from "../SurveyFormComposedInput";

export const SurveyFormBooleanWithDateInput = (props) =>
    <SurveyFormComposedInput Validation={props.Validation}>
        <SurveyFormInputBoolean {...props} Validation={null}/>
        <SurveyFormInputDate {...props} Validation={null}/>
    </SurveyFormComposedInput>;
